<template>
  <div class="xcar pb-0 mb-0">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">
      REPORTE RECAUDACIÓN MENSUAL
    </h4>

    <v-row dense class="ml-2">
      <v-col cols="2">
        <v-combobox
          v-model="filtros.gestion"
          :items="gestiones"
          label="Gestion"
          :disabled="loading"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
          v-model="filtros.mes"
          :items="meses"
          label="Mes"
          :disabled="loading"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
          v-model="filtros.unidad"
          :items="unidades"
          label="Unidad de Negocio"
          :disabled="loadingunidades || loading"
          :loading="loadingunidades"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
    </v-row>

    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <div class="text-center ma-0" v-if="loading">
      <div style="display: inline-block;" v-if="loading" class="loader"></div>
    </div>

    <!-- <div><AAsignacionTablaR ref="asignacionestablar" v-on:dataloaded="dataloaded" /></div> -->
  </div>
</template>

<script>
  /* import AAsignacionTablaR from '@/components/AAsignacionTablar.vue'; */
  import gql from 'graphql-tag';

  export default {
    data() {
      return {
        msg: '',
        loading: false,
        loadingunidades: false,
        gestiones: [2024,2023,2022, 2021, 2020, 2019, 2018],
        meses: [
          { id: 1, text: 'Enero' },
          { id: 2, text: 'Febrero' },
          { id: 3, text: 'Marzo' },
          { id: 4, text: 'Abril' },
          { id: 5, text: 'Mayo' },
          { id: 6, text: 'Junio' },
          { id: 7, text: 'Julio' },
          { id: 8, text: 'Agosto' },
          { id: 9, text: 'Septiembre' },
          { id: 10, text: 'Octubre' },
          { id: 11, text: 'Noviembre' },
          { id: 12, text: 'Diciembre' },
        ],
        unidades: [],
        filtros: {
          gestion: null,
          mes: null,
          unidad: null,
        },
      };
    },
    components: {},
    watch: {
      'filtros.gestion': function() {
        if (this.filtros.gestion) this.listarsignaciones();
      },
      'filtros.mes': function() {
        if (this.filtros.mes) this.listarsignaciones();
      },
      'filtros.unidad': function() {
        if (this.filtros.unidad) this.listarsignaciones();
      },
    },
    methods: {
      listarsignaciones() {
        if (!this.filtros.gestion) return;
        if (!this.filtros.mes) return;
        if (!this.filtros.unidad) return;
        let anio = this.filtros.gestion;
        let mes = this.filtros.mes.id;
        let unidad = this.filtros.unidad.id;
        if (this.loading) return;
        this.loading = true;
        this.$refs.asignacionestablar.obtenerasignaciones(mes, anio, unidad);
      },
      async getunidades() {
        var vue = this;
        this.filtros.unidad = null;
        this.loadingunidades = true;
        var sql = gql`
          query {
            NegociosAll {
              id
              nombre
            }
          }
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.NegociosAll;
            dat.map((x) => {
              x.text = x.nombre;
            });
            vue.unidades = dat;
            vue.loadingunidades = false;
            let unidad = vue.$store.state.CARGO.sede.unidad_negocio;
            vue.filtros.unidad = dat.find((u) => u.id == unidad);
            //window.console.log('>>> ', unidad, JSON.stringify(dat, null, 4), vue.filtros.unidad);
          })
          .catch((error) => {
            vue.loadingunidades = false;
            window.console.error(error);
          });
      },
      defaultdata() {
        let date = new Date();
        let anio = date.getFullYear();
        let mes = date.getMonth() + 1;
        this.filtros.gestion = '' + anio;
        this.filtros.mes = this.meses.find((x) => x.id == mes);
      },
      dataloaded() {
        this.loading = false;
      },
    },
    mounted() {
      this.getunidades();
      this.defaultdata();
    },
  };
</script>
